"use strict";
'kiwi public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _AwayStatusIndicator = _interopRequireDefault(require("./AwayStatusIndicator"));
var _TypingStatusIndicator = _interopRequireDefault(require("./TypingStatusIndicator"));
var _UserAvatar = _interopRequireDefault(require("./UserAvatar"));
var _default = exports.default = {
  components: {
    AwayStatusIndicator: _AwayStatusIndicator.default,
    TypingStatusIndicator: _TypingStatusIndicator.default,
    UserAvatar: _UserAvatar.default
  },
  props: ['network', 'user', 'nicklist'],
  computed: {
    dataAttributes: function dataAttributes() {
      var attrs = Object.create(null);
      attrs['data-nick'] = this.user.nick.toLowerCase();
      if (this.user.account) {
        attrs['data-account'] = this.user.account.toLowerCase();
      }
      var userMode = this.nicklist.buffer.userMode(this.user);
      if (userMode) {
        attrs['data-mode'] = userMode;
      }
      return attrs;
    },
    userColour: function userColour() {
      if (this.nicklist.useColouredNicks) {
        return this.user.getColour();
      }
      return '';
    },
    userModePrefix: function userModePrefix() {
      return this.nicklist.buffer.userModePrefix(this.user);
    },
    displayPrefix: function displayPrefix() {
      if (this.isOperator) {
        return '🛡️';
      }
      if (this.isVoice) {
        return '⭐';
      }
      if (this.genderCode === 'h') {
        return '🕺';
      }
      if (this.genderCode === 'm') {
        return '🌸';
      }
      if (this.genderCode === 'o') {
        return '🌈';
      }
      return '🙂';
    },
    prefixClass: function prefixClass() {
      if (this.isOperator) {
        return 'chatlatinos-prefix-op';
      }
      if (this.isVoice) {
        return 'chatlatinos-prefix-voice';
      }
      return 'chatlatinos-prefix-gender';
    },
    prefixTitle: function prefixTitle() {
      if (this.isOperator) {
        return 'Operador';
      }
      if (this.isVoice) {
        return 'Voice';
      }
      if (this.genderCode === 'h') {
        return 'Hombre';
      }
      if (this.genderCode === 'm') {
        return 'Mujer';
      }
      if (this.genderCode === 'o') {
        return 'Diverso';
      }
      return 'Libre';
    },
    genderCode: function genderCode() {
      if (this.nicklist && this.nicklist.genderForUser) {
        return this.nicklist.genderForUser(this.user);
      }
      return 'n';
    },
    isOperator: function isOperator() {
      var mode = this.nicklist.buffer.userMode(this.user);
      var operatorModes = ['q', 'a', 'o', 'h'];
      var operatorPrefixes = ['~', '&', '@', '%'];
      return operatorModes.indexOf(mode) !== -1 || operatorPrefixes.indexOf(this.userModePrefix) !== -1;
    },
    isVoice: function isVoice() {
      var mode = this.nicklist.buffer.userMode(this.user);
      return mode === 'v' || this.userModePrefix === '+';
    },
    userTypingState: function userTypingState() {
      var status = this.user.typingStatus(this.nicklist.buffer.name).status;
      return status;
    }
  }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["NicklistUser"]
window._kiwi_exports.components.NicklistUser = exports.default ? exports.default : exports;
